// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".navigate-to-plan-select[data-v-d27f3d2e]{font-size:16px}.heading[data-v-d27f3d2e]{display:flex;flex-direction:row;justify-content:center;align-items:center;gap:8px;font-weight:700;font-size:14px;line-height:150%}.heading-icon[data-v-d27f3d2e]{width:16px;height:16px;border-radius:8px;background-color:#404040}", ""]);
// Exports
module.exports = exports;
